import {Environment} from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://m.api.mabble.co.za'
};
